<script>import Input from "../Input.svelte";
import { clickOutside } from "../../../../actions";
import { attrValue } from "../../../../utils/html";
import { fade } from "svelte/transition";
import SVG from "../../SVG.svelte";
import { capitalize } from "../../../../utils/strings";
import InputText from "./InputText.svelte";
import DynamicComponent from "../../../components/DynamicComponent.svelte";
export let props;
export let isDropdownOpen = false;
let searchValue = "";
let searchInputProps = { placeholder: props.searchPlaceholder, classNames: "border-grey" };
$: searchValue = searchInputProps?.value ? searchInputProps?.value : "";
$: disabled = props && props.disabled;
$: ddOpenClass = isDropdownOpen ? "open" : "";
$: searchedData = (p) => p.filter(
  (d) => Array.isArray(d.value) || d.label.toLowerCase().includes(searchValue.toLowerCase())
);
$: optionsList = props && props.withSearchBar && props?.options ? searchedData(props?.options) : props?.options;
$: selectedClass = (o) => props.value && (props.value === o.value || Array.isArray(props.value) && props.value.findIndex((e) => e === o.value) !== -1) ? "selected" : "";
$: disabledClass = (o) => o.disabled ? "disabled" : "";
$: getSelectedLabel = () => {
  let label = props.placeholder;
  if (props?.options) {
    props.options.forEach((e) => {
      if (e.value === props.value) {
        label = e.label;
      } else if (Array.isArray(e.value)) {
        e.value.forEach((i) => {
          if (i.value === props.value) {
            label = i.label;
          }
        });
      }
    });
  }
  return label;
};
const getLabelByValue = (v) => {
  const opt = props.options?.find((e) => e.value === v);
  return opt?.label ?? v;
};
const resetLocalState = () => {
  isDropdownOpen = false;
  searchValue = "";
};
const toggleDropdown = () => {
  if (!disabled) {
    isDropdownOpen = !isDropdownOpen;
    searchValue = "";
  }
};
const unselectItem = (v) => {
  if (Array.isArray(props.value)) {
    props.value = props.value.filter((e) => e !== v);
  }
};
const selectItem = (i) => {
  if (!i.disabled) {
    if (!props.multiple) {
      props.value = i.value;
      isDropdownOpen = false;
    } else if (Array.isArray(props.value)) {
      let index = props.value.findIndex((e) => e === i.value);
      if (index !== -1) {
        unselectItem(i.value);
      } else {
        props.value = [...props.value, i.value];
      }
    }
    if (!props.dirty) {
      props.dirty = true;
    }
  }
  props = props;
};
</script>

<Input bind:props>
	<div
		use:clickOutside={{ action: resetLocalState }}
		class={attrValue(['select-container cursor-pointer', ddOpenClass, props?.classNames || ''])}
		{disabled}
	>
		<!-- svelte-ignore a11y-click-events-have-key-events -->
		<!-- svelte-ignore a11y-no-static-element-interactions -->
		<div class="select select__trigger" on:click={toggleDropdown}>
			{#if props.multiple}
				<div class="flex flex-wrap space-x-1 mr-4">
					{#if props.value && props.value.length}
						{#each props.value as v}
							<div
								class="selected-item"
								on:click|stopPropagation={() => !props.disabled && unselectItem(v)}
								in:fade|global={{ duration: 200 }}
								out:fade|global={{ duration: 200 }}
								class:disabled={props.disabled}
							>
								<span class="selected-item__label">{capitalize(getLabelByValue(v))}</span>
								<SVG size="small" name="close" />
							</div>
						{/each}
					{:else}
						<span class="mr-4"
							>{props.placeholderMultiple}</span
						>
					{/if}
				</div>
			{:else}
				{@const selectedLabel = getSelectedLabel()}
				{#if selectedLabel}
					<span class="mr-4 first-letter:uppercase">
						{#if typeof selectedLabel == 'string'}
							{selectedLabel}
						{:else if typeof selectedLabel == 'boolean'}
							<div class="flex space-x-2">
								<SVG
									name={selectedLabel ? 'check_circle' : 'close_circle'}
									classNames={selectedLabel ? 'text-success' : 'text-error'}
								/>
								<span>{selectedLabel ? 'Valide / complété' : 'Invalide / incomplet'}</span>
							</div>
						{:else}
							<div class="flex items-center gap-2">
								<DynamicComponent component={selectedLabel} />
								{#if selectedLabel.props?.props?.tooltip?.title}
									<span>{selectedLabel.props?.props?.tooltip?.title}</span>
								{/if}
							</div>
						{/if}
					</span>
					{/if}
			{/if}
			<SVG
				name="arrow_down_square"
				classNames="transform text-secondary transition {!isDropdownOpen ? '-rotate-90' : ''}"
				size="small"
			/>
		</div>
		<div class="options">
			{#if props.withSearchBar}
				<div class="options__actions">
					<InputText bind:props={searchInputProps} />
				</div>
			{/if}
			{#if optionsList}
				{#each optionsList as d}
					{#if Array.isArray(d.value)}
						<span class="category">{d.label}</span>
						{#each props.withSearchBar ? searchedData(d.value) : d.value as e}
							<!-- svelte-ignore a11y-click-events-have-key-events -->
							<!-- svelte-ignore a11y-no-static-element-interactions -->
							<span
								class={attrValue([
									'option',
									'pl-5 pr-3',
									selectedClass(e),
									disabledClass(e),
									disabledClass(d)
								])}
								class:disabled={props.disabled}
								on:click={() => {
									!props.disabled && !d.disabled && selectItem(e);
								}}
							>
								{capitalize(e.label)}
							</span>
						{/each}
					{:else}
						<!-- svelte-ignore a11y-click-events-have-key-events -->
						<!-- svelte-ignore a11y-no-static-element-interactions -->
						<span
							class={attrValue([
								'option first-letter:uppercase',
								'px-3',
								selectedClass(d),
								disabledClass(d)
							])}
							on:click={() => {
								selectItem(d);
							}}
							on:click
						>
							{#if typeof d.label == 'string'}
								{d.label}
							{:else if typeof d.label == 'boolean'}
								<div class="flex space-x-2">
									<SVG
										name={d.label ? 'check_circle' : 'close_circle'}
										classNames={d.label ? 'text-success' : 'text-error'}
									/>
									<span>{d.label ? 'Valide / complété' : 'Invalide / incomplet'}</span>
								</div>
							{:else}
								<div class="flex items-center gap-2">
									<DynamicComponent component={d.label} />
									{#if d.label?.props?.props?.tooltip?.title}
										<span>{d.label?.props?.props?.tooltip?.title}</span>
									{/if}
								</div>
							{/if}
						</span>
					{/if}
				{/each}
			{/if}
		</div>
	</div>
	{#if props.multiple}
		<select {disabled} id={props.id} bind:value={props.value} multiple />
	{:else}
		<select {disabled} id={props.id} bind:value={props.value} />
	{/if}
</Input>

<style>select{display:none}.select-container{display:flex;flex-direction:column;overflow:hidden;position:relative;-webkit-user-select:none;-moz-user-select:none;user-select:none;width:100%}.select-container.open{overflow:visible}.select-container[disabled=true] .select__trigger{cursor:not-allowed;opacity:.5}.select-container[disabled=false] .select__trigger{cursor:pointer}.select__trigger{--tw-border-opacity:1;border-color:#e6e6e6;border-color:rgba(230,230,230,var(--tw-border-opacity,1));--tw-bg-opacity:1;background-color:#fff;background-color:rgba(255,255,255,var(--tw-bg-opacity,1))}.select__trigger::-moz-placeholder{--tw-placeholder-opacity:1;color:#f7f7f7;color:rgba(247,247,247,var(--tw-placeholder-opacity,1))}.select__trigger::placeholder{--tw-placeholder-opacity:1;color:#f7f7f7;color:rgba(247,247,247,var(--tw-placeholder-opacity,1))}.select__trigger{align-items:center;display:flex;justify-content:space-between;line-height:1.5;padding:.5rem 1rem;position:relative;transition-duration:.15s;transition-property:color,background-color,border-color,text-decoration-color,fill,stroke,opacity,box-shadow,transform,filter,-webkit-backdrop-filter;transition-property:color,background-color,border-color,text-decoration-color,fill,stroke,opacity,box-shadow,transform,filter,backdrop-filter;transition-property:color,background-color,border-color,text-decoration-color,fill,stroke,opacity,box-shadow,transform,filter,backdrop-filter,-webkit-backdrop-filter;transition-timing-function:cubic-bezier(.4,0,.2,1)}.select-container.open .select__trigger{border-bottom-left-radius:0;border-bottom-right-radius:0;border-color:var(--color-secondary)}.selected-items{display:flex}.selected-item{align-items:center;border-radius:9999px;border-width:1px;display:flex;font-size:.75rem;line-height:.75rem;margin:.25rem;padding:.25rem .5rem;--tw-border-opacity:1;border-color:#e6e6e6;border-color:rgba(230,230,230,var(--tw-border-opacity,1));transition-duration:.5s;transition-property:color,background-color,border-color,text-decoration-color,fill,stroke,opacity,box-shadow,transform,filter,-webkit-backdrop-filter;transition-property:color,background-color,border-color,text-decoration-color,fill,stroke,opacity,box-shadow,transform,filter,backdrop-filter;transition-property:color,background-color,border-color,text-decoration-color,fill,stroke,opacity,box-shadow,transform,filter,backdrop-filter,-webkit-backdrop-filter;transition-timing-function:cubic-bezier(.4,0,.2,1)}.selected-item:not(.disabled):hover{--tw-bg-opacity:1;background-color:#e6e6e6;background-color:rgba(230,230,230,var(--tw-bg-opacity,1))}.selected-item__label{margin-right:.25rem}.options{border-bottom-left-radius:.5rem;border-bottom-right-radius:.5rem;border-color:var(--color-secondary);border-width:0 1px 1px;--tw-bg-opacity:1;background-color:#fff;background-color:rgba(255,255,255,var(--tw-bg-opacity,1));display:block;left:0;opacity:0;pointer-events:none;position:absolute;right:0;top:100%;transition-duration:.15s;transition-property:color,background-color,border-color,text-decoration-color,fill,stroke,opacity,box-shadow,transform,filter,-webkit-backdrop-filter;transition-property:color,background-color,border-color,text-decoration-color,fill,stroke,opacity,box-shadow,transform,filter,backdrop-filter;transition-property:color,background-color,border-color,text-decoration-color,fill,stroke,opacity,box-shadow,transform,filter,backdrop-filter,-webkit-backdrop-filter;transition-timing-function:cubic-bezier(.4,0,.2,1);visibility:hidden;z-index:10}.options__actions{padding:1rem}.options__actions :global(input){border-radius:.25rem;display:block;filter:none;width:100%;--tw-bg-opacity:1;background-color:#fff;background-color:rgba(255,255,255,var(--tw-bg-opacity,1));transition-duration:.15s;transition-property:color,background-color,border-color,text-decoration-color,fill,stroke,opacity,box-shadow,transform,filter,-webkit-backdrop-filter;transition-property:color,background-color,border-color,text-decoration-color,fill,stroke,opacity,box-shadow,transform,filter,backdrop-filter;transition-property:color,background-color,border-color,text-decoration-color,fill,stroke,opacity,box-shadow,transform,filter,backdrop-filter,-webkit-backdrop-filter;transition-timing-function:cubic-bezier(.4,0,.2,1)}.options__actions :global(input):focus{border-color:var(--color-primary);outline:2px solid transparent;outline-offset:2px;--tw-ring-offset-shadow:var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);--tw-ring-shadow:var(--tw-ring-inset) 0 0 0 calc(var(--tw-ring-offset-width)) var(--tw-ring-color);box-shadow:var(--tw-ring-offset-shadow),var(--tw-ring-shadow),0 0 transparent;box-shadow:var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow,0 0 transparent)}.select-container.open .options{max-height:300px;opacity:1;overflow-x:hidden;overflow-y:auto;pointer-events:auto;visibility:visible}.category{background-color:var(--color-secondary);display:block;line-height:1.25;padding:.5rem 1rem;position:relative;--tw-text-opacity:1;color:#fff;color:rgba(255,255,255,var(--tw-text-opacity,1))}.option{display:block;line-height:1.5;padding-bottom:.5rem;padding-top:.5rem;position:relative;transition-duration:.15s;transition-property:color,background-color,border-color,text-decoration-color,fill,stroke,opacity,box-shadow,transform,filter,-webkit-backdrop-filter;transition-property:color,background-color,border-color,text-decoration-color,fill,stroke,opacity,box-shadow,transform,filter,backdrop-filter;transition-property:color,background-color,border-color,text-decoration-color,fill,stroke,opacity,box-shadow,transform,filter,backdrop-filter,-webkit-backdrop-filter;transition-timing-function:cubic-bezier(.4,0,.2,1)}.option:not(.disabled){cursor:pointer}.option:hover:not(.disabled):not(.selected){--tw-bg-opacity:1;background-color:#f7f7f7;background-color:rgba(247,247,247,var(--tw-bg-opacity,1))}.option.selected{--tw-bg-opacity:1;background-color:#9597a4;background-color:rgba(149,151,164,var(--tw-bg-opacity,1));--tw-text-opacity:1;color:#fff;color:rgba(255,255,255,var(--tw-text-opacity,1))}.arrow{height:1rem;position:relative;width:1rem}.arrow:after,.arrow:before{content:"";height:100%;position:absolute;transition-duration:.5s;transition-property:color,background-color,border-color,text-decoration-color,fill,stroke,opacity,box-shadow,transform,filter,-webkit-backdrop-filter;transition-property:color,background-color,border-color,text-decoration-color,fill,stroke,opacity,box-shadow,transform,filter,backdrop-filter;transition-property:color,background-color,border-color,text-decoration-color,fill,stroke,opacity,box-shadow,transform,filter,backdrop-filter,-webkit-backdrop-filter;transition-timing-function:cubic-bezier(.4,0,.2,1);width:.125em}.arrow:before{left:-5px;transform:rotate(45deg)}.arrow:after,.arrow:before{background-color:currentColor}.arrow:after{left:5px;transform:rotate(-45deg)}.open .arrow:before{left:-5px;transform:rotate(-45deg)}.open .arrow:after{left:5px;transform:rotate(45deg)}</style>
